import React from "react";

const ProductTour = () => null;

export default ProductTour;
